import { FC, useContext } from 'react';
import { ProviderHubContext } from '@app/projects/network-assessment/provider-hub/contexts/ProviderHubContext';
import { QESButton } from '@app/shared/qes-standards/Button';
import { QESSelect } from '@app/shared/qes-standards/forms/Select';

export const AccessPointCardsPaging: FC = () => {

  const availablePageSizes = [25, 50, 100];

  const providerHubContext = useContext(ProviderHubContext);

  const handlePageSizeChange = (newSize: number) => {
    providerHubContext.setAccessPointsPageSize(newSize);
    providerHubContext.setAccessPointsPage(1);
   
  };

  const handlePageChange = (increment: number) => {
    const page = providerHubContext.accessPointsPage + increment;
    providerHubContext.setAccessPointsPage(page);
  };

  return (
    <div className="provider-profile__access-points-pagination">
      <div className="d-flex justify-content-between align-items-center mt-2">
        <QESButton
          qesType="secondary"
          disabled={providerHubContext.accessPointsPage <= 1}
          onClick={() => handlePageChange(-1)}
          qesTestId="provider-profile__access-points-prev-page-button"
        >
          Previous
        </QESButton>
        <span className="provider-profile__page-of">Page {providerHubContext.accessPointsPage} of {providerHubContext.totalAccessPointsPages}</span>
        <QESButton
          qesType="secondary"
          disabled={providerHubContext.accessPointsPage >= providerHubContext.totalAccessPointsPages}
          onClick={() => handlePageChange(1)}
          qesTestId="provider-profile__access-points-next-page-button"
        >
          Next
        </QESButton>
      </div>
      <div className="mt-0 d-flex justify-content-center">
        <div className="mt-0 d-flex align-items-center">
          <div className="qes-select__label">Page Size</div>
          <QESSelect
            id="page-size-select"
            className="form-select"
            label="Page Size"
            hideLabel={true}
            value={providerHubContext.accessPointsPageSize}
            containerClassName="d-flex flex-row align-items-center qes-select__label-padding-left"
            onChange={e => { handlePageSizeChange(Number(e.target.value)) }}
            testId="provider-profile__access-points-page-size-select"
          >
            {availablePageSizes.map(size => (
              <option key={size} value={size}>{size}</option>
            ))}
          </QESSelect>
        </div>
      </div>
    </div>
  );
  
};